import styled from "styled-components";

export const GptContainer = styled.div.attrs({
})`
    display: flex;
    flex-direction: column;
    width: 100%;
    border-top: 1px solid ${props => props.theme.palette.colors.borderSoft};
    padding: 32px clamp(18px, 3vw, 40px);
    height: ${p => p.isMessage ? 'calc(100vh - 80px)' : 'calc(100vh - 120px)'};
    background:
      radial-gradient(circle at top left, ${props => props.theme.palette.colors.shellGradientStart} 0%, ${props => props.theme.palette.colors.backgroundTransparent} 36%),
      ${props => props.theme.palette.colors.background};
`;

export const GptContent = styled.div.attrs({
})`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    gap: 16px;
`;

export const ChatContainer = styled.div.attrs({
})`
    height: 100%;
    width: 100%;
    border: 1px solid ${props => props.theme.palette.colors.borderSoft};
    border-radius: 28px;
    padding: 24px;
    background: ${props => props.theme.palette.colors.surfaceElevatedSoft};
    box-shadow: 0 24px 56px ${props => props.theme.palette.colors.shadowStrong};
`;

export const IconContainer = styled.div.attrs({
})`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    gap: 16px;
    flex-direction: column;
`;

export const ChatExample = styled.div.attrs({
})`
  display: flex;
  gap: 16px;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;
`;

export const OptionExample = styled.div.attrs({
})`
  width: 100%;
  max-width: 240px;
  background: ${props => props.theme.palette.colors.surfaceElevated};
  padding: 12px 14px;
  border: 1px solid ${props => props.theme.palette.colors.borderSoft};
  border-radius: 18px;
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  cursor: pointer;
  color: ${props => props.theme.palette.colors.text};
`;

export const GptBody = styled.div.attrs({
})`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  min-height: 50lvh;
  max-height: 50lvh;
  overflow: auto;
`;

export const Title = styled.div.attrs({
})`
  font-family: Gilroy;
  font-size: 24px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
  color: ${props => props.theme.palette.colors.text};
`;

export const ChatBaloon = styled.div.attrs({
})`
  font-family: Inter;
  font-size: 14px;
  color: ${props => props.theme.palette.colors.text};
  background: ${props => props.me ? props.theme.palette.blue.main : props.theme.palette.colors.surfaceElevated};
  padding: 10px 14px;
  max-width: 70%;
  border-radius: 16px;
  border: 1px solid ${props => props.theme.palette.colors.borderSoft};
  ${p => p.me ? `
      align-self: flex-end;
      ` : `
      align-self: flex-start;
    `
  }
`;
